import { TableRecord } from '@/models/TableRecord'

export class DatasetRecord extends TableRecord {
  public name?: string
  public description?: string
  public timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
  public isEnabled: boolean = true
  public isSandbox: boolean = false
  public isInitialized: boolean = false
}
